export const slugifyWithoutHyphens = (input: string) => {
  return input
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "") // Remove spaces completely
    .replace(/[^\w]+/g, "") // Remove all non-word chars (including hyphens)
    .trim(); // Trim any whitespace
};
